<template>
  <legend class="app-legend">
    <slot />
  </legend>
</template>

<script>
export default {
  name: 'AppLegend',
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';
@import '@/styles/functions.scss';

.app-legend {
  width: 100%;
  line-height: 1.5;
  padding: 0 0 0.25em;
  margin-bottom: 1.25em;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
}
</style>
